export default __webpack_public_path__ + "static/media/qr.d243b51a.svg";